var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingApprovals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4811 11.9954L9.14981 2.66565C9.03357 2.46053 8.86499 2.28992 8.66128 2.17122C8.45757 2.05252 8.22602 1.98997 7.99025 1.98997C7.75449 1.98997 7.52294 2.05252 7.31923 2.17122C7.11552 2.28992 6.94694 2.46053 6.8307 2.66565L1.4994 11.9954C1.3819 12.1989 1.32028 12.4299 1.3208 12.6648C1.32132 12.8998 1.38396 13.1305 1.50236 13.3335C1.62076 13.5364 1.79072 13.7045 1.995 13.8206C2.19929 13.9367 2.43065 13.9968 2.66562 13.9947H13.3282C13.5621 13.9944 13.7917 13.9327 13.9942 13.8156C14.1966 13.6985 14.3646 13.5302 14.4815 13.3277C14.5983 13.1251 14.6597 12.8953 14.6597 12.6615C14.6596 12.4276 14.598 12.1979 14.4811 11.9954Z",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 5.99771V8.66336",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99707 11.329H8.00373",
    stroke: "white",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApprovals);
export default __webpack_public_path__ + "static/media/pendingApprovals.c967e36039c198af7b6d4b918ad36bdd.svg";
export { ForwardRef as ReactComponent };